import cn from "classnames";
import styles from "./Tabs.module.scss";

interface ITabControlGroupProps {
  className?: string;
}

export const TabsControlGroup: RFC<ITabControlGroupProps> = ({ className, children }) => {
  return <div className={cn(styles.group, className)}>{children}</div>;
};

TabsControlGroup.displayName = "TabsControlGroup";
